import { fetchGet, fetchPatch, fetchPost } from "@/lib/services";

export async function getReferralDetails(page: number) {
  return await fetchGet(`/referral/?page=${page}`);
}

export async function createReferral(formData: FormData) {
  return await fetchPost("/referral/", formData, true);
}

export async function updateReferral(id: number, data: FormData) {
  return await fetchPatch(`/referral/?Id=${id}`, data,true);
}

export async function getOffers() {
  return await fetchGet(`/offers/`);
}

export async function createOffer(formData: FormData) {
  return await fetchPost("/offers/", formData, true);
}

export async function updateOffer(id: number, data: FormData) {
  return await fetchPatch(`/offers/?Id=${id}`, data,true);
}

export async function getTrailOffers(status?: string) {
  const params = new URLSearchParams();
  const query = params.toString() ? `?${params.toString()}` : '';
  if (status) params.append('Status', status);
  return await fetchGet(`/trails-offer/${query}`);
}

export async function createTrailOffer(data: FormData) {
  return await fetchPost("/trails-offer/", data,true);
}

export async function updateTrailOffer(id: number, data: FormData) {
  return await fetchPatch(`/trails-offer/?Id=${id}`, data,true);
}

export async function getRewardAmount(username: string) {
  return await fetchGet(`/reward_amount/?Username=${username}`);
}

export async function getSpecialOffers() {
  return await fetchGet(`/special-offer/`);
}

export async function createSpecialOffer(formData: any) {
  return await fetchPost("/special-offer/", formData, true);
}

export async function updateSpecialOffer(id: number, data: any) {
  return await fetchPatch(`/special-offer/?Id=${id}`, data,true);
}

export async function getChildSpecialOffer(childIds: number[]) {
  return await fetchGet(
    `/special-offer-amount/?child_id=${childIds.join(",")}`
  );
}

export const formatDate = (
  date: string | Date | null | undefined,
  locale = "en-GB"
): string => {
  if (!date) return "—";

  return new Intl.DateTimeFormat(locale, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(new Date(date));
};

export async function getAppVersions() {
  return await fetchGet(`/app-version/`);
}

export async function createAppVersion(data: any) {
  return await fetchPost("/app-version/", data);
}

export async function updateAppVersionStatus(id: number, data: any) {
  return await fetchPatch(`/app-version/?Id=${id}`, data);
}